<template>
  <div>
    <EmptyContact v-if="contacts.length == 0"/>

    <v-col v-else>
      <ContactHeader @openModal='openModal' />

      <div class="t-body">
        <div
          class="d-flex t-border"
          v-for="(item, index) in contacts"
          :key="index"
        >
          <v-col cols="5" align-self="center" class="px-0">
            <div>{{ item.title == '' ? item.type : item.title }}</div>
          </v-col>

          <v-col cols="5" align-self="center">
            <div>{{ item.value }}</div>
          </v-col>

          <v-col cols="2" align="end" align-self="center" class="px-0">
            <v-btn
              class="mr-2"
              icon
              @click="onEdit(item)"
            >
              <v-icon color="#BDBDBD">mdi-square-edit-outline</v-icon>
            </v-btn>

            <v-btn
              icon
              @click="onDelete(item)"
            >
              <v-icon color="#BDBDBD">mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-col>
        </div>
      </div>
    </v-col>
  </div>
</template>

<script>
import ContactHeader from "@/components/lfs/Badges/ListItems/ContactHeader.vue"
import EmptyContact from "@/components/lfs/Layouts/EmptyListInfo/EmptyContact.vue"

export default {
  props: ['contacts'],

  components: {
    EmptyContact,
    ContactHeader
  },

  data: () => ({
    isOpen: false,
    currentContact: {}
  }),


  methods: {
    openModal() {
      this.isOpen = true
    },

    closeModal() {
      this.isOpen = false
      this.currentContact = {}
    },

    onEdit(item) {
      this.currentContact = item
      console.log(item, 'edit');
    },

    onDelete(item) {
      this.$emit('onDelete', item)
    }
  }
}
</script>

<style lang="scss" scoped>
  .t-body {
    padding: 0 1rem;
    border-radius: 8px;
    background-color: #F3F2F7;
  }

  .t-border {
    border-bottom: 1px solid rgba(217, 217, 217, 0.64);
  }

  .t-body > .t-border {
    &:last-child {
      border: none;
    }
  }
</style>
